import { useMemo } from 'react';
import { apiBaseOrigin } from '../../../shared/config/api-origin';
import { Card } from '../../../shared/ui/Primitives';
import { createAutonomousAdapter } from '../adapters/autonomous-http';
import { autonomousKpis } from '../consumer/autonomous';
import { riskHref } from '../consumer/workbench';
import { AutonomousStatus } from './AutonomousStatus';
import { useWorkspaceRead } from './command-workspace/workspace-reads';

/** Same endpoint and component as the dedicated risk-warning page. */
export function OverviewMonitoringSummary() {
  const port = useMemo(() => createAutonomousAdapter({ baseOrigin: apiBaseOrigin() }), []);
  const read = useMemo(() => (signal: AbortSignal) => port.read('', signal), [port]);
  const state = useWorkspaceRead(read, 0, 3000);
  return (
    <Card zone="nm-overview-autonomous" title="自动监测 · 合成演练 / 非运营">
      <AutonomousStatus state={state} />
      <dl data-vs10-overview>
        {autonomousKpis(state).map((kpi) => (
          <div key={kpi.key} title={kpi.note}>
            <dt>{kpi.label}</dt>
            <dd data-vs10-kpi={kpi.key}>{kpi.value ?? '未知'}</dd>
          </div>
        ))}
      </dl>
      <small>
        全部当前授权区域 · {state.status === 'READY' ? state.data?.asOf : '后端时间未知'}
      </small>
      <p>
        <a href={riskHref()}>查看风险与预警 →</a>
      </p>
    </Card>
  );
}
